import { ReactTyped } from "react-typed";
import { IoMdSearch } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { CiBoxList } from "react-icons/ci";
import { RiBubbleChartLine } from "react-icons/ri";

function Header({ onSearchClick, viewMode, setViewMode }) {
  const navigate = useNavigate();

  return (
    <header className="header">
      <div 
        className="header-left" 
        onClick={() => navigate("/")} 
      >
        <img src="/jway-col.png" alt="logo" className="logo" />
        <h1 className="company-name">
          J<span className="company-name-highlight">work</span>
        </h1>
      </div>

      <div className="header-right">
        <h1 className="solutions">
          <ReactTyped
            strings={["< Nos Solutions", "< Innovantes", "< Adaptées à Vous"]}
            typeSpeed={80}
            backSpeed={50}
            backDelay={1500}
            showCursor={true}
            cursorChar=" />"
            loop={true}
          />
        </h1>
      </div>

      <div className="search">
        {viewMode === "list" ? (
          <div className="tooltip-wrapper">
            <RiBubbleChartLine 
              className="search-icon list-button bubbled"
              onClick={() => {
                setViewMode("bubbles");
                navigate("/");
              }}
            />
            <span className="tooltip">Switch to bubbles view</span>
          </div>
        ) : (
          <div className="tooltip-wrapper">
            <CiBoxList 
              className="search-icon list-button listed"
              onClick={() => {
                setViewMode("list");
                navigate("/");
              }}
            />
            <span className="tooltip">Switch to list view</span>
          </div>
        )}


        <IoMdSearch
          className="search-icon"
          onClick={onSearchClick}
        />
      </div>
    </header>
  );
}

export default Header;
